import shop from '~/lib/api/shop';
import { ShopTypes } from '~/lib/data-contract';
import shopErrors from '~/services/shop/errors';
import { getUrl } from '~/services/shop/utils';

export default function getOrderStatus(reference: string | undefined, email: string | undefined) {
    if (!reference) {
        return Promise.reject(new Error(shopErrors.referenceNotFound.message));
    }

    if (!email) {
        return Promise.reject(new Error(shopErrors.emailNotProvided.message));
    }

    const url = getUrl(`/order/status/${reference}`);

    url.searchParams.set('email', email);

    return shop.get(url).json<ShopTypes.OrderStatusResponse>();
}
